import { render, staticRenderFns } from "./alternateMaterialModal.vue?vue&type=template&id=ac3b2174&scoped=true&"
import script from "./alternateMaterialModal.vue?vue&type=script&lang=js&"
export * from "./alternateMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./alternateMaterialModal.vue?vue&type=style&index=0&id=ac3b2174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3b2174",
  null
  
)

export default component.exports